import { render, staticRenderFns } from "./linkageFrom.vue?vue&type=template&id=71bf14ac&scoped=true&"
import script from "./linkageFrom.vue?vue&type=script&lang=js&"
export * from "./linkageFrom.vue?vue&type=script&lang=js&"
import style0 from "./linkageFrom.vue?vue&type=style&index=0&id=71bf14ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf14ac",
  null
  
)

export default component.exports